export enum CurrencyCode {
  RUB = 'RUB',
  EUR = 'EUR',
  USD = 'USD',
}
